import React from 'react';
import { useReveal } from '../lib/useReveal';
const TOMOS = [{
  num: '1',
  title: 'El Despertar del Canal',
  emoji: '📘',
  desc: 'El origen, la historia y los principios del Sistema Usui Reiki. Cómo abrir y activar tu canal energético desde el primer día.'
}, {
  num: '2',
  title: 'Simbología y Distancia',
  emoji: '📗',
  desc: 'Los símbolos sagrados del Reiki Nivel II. Técnicas de Reiki a distancia. Cómo trabajar más allá del tiempo y el espacio.'
}, {
  num: '3',
  title: 'La Maestría Espiritual',
  emoji: '📙',
  desc: 'El camino completo hacia la Maestría. Integración de los tres niveles. Profundización espiritual y práctica avanzada.'
}, {
  num: '4',
  title: 'El Manual del Iniciador',
  emoji: '📕',
  desc: 'El protocolo más completo de sintonizaciones en español. Paso a paso. Exactamente qué hacer. Exactamente qué decir. Para tus propios alumnos.'
}, {
  num: '5',
  title: 'Reiki Business · Salida Laboral',
  emoji: '📓',
  desc: 'Cómo convertir tu práctica en un negocio real. Precios, clientes, redes sociales y todo lo que necesitás para vivir del Reiki.'
}, {
  num: '6',
  title: 'Protocolos de Emergencia',
  emoji: '📔',
  desc: 'Los protocolos específicos para situaciones críticas. Cómo actuar cuando un cliente lo necesita con urgencia real.'
}];
export function HowItWorksSection() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-black py-12 md:py-16 px-5 sm:px-6 border-t border-white/5" data-id="element-248">
      <div className="container mx-auto max-w-4xl" data-id="element-249">
        <div ref={ref1} className={`reveal text-center mb-10 ${vis1 ? 'is-visible' : ''}`} data-id="element-250">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-3" style={{
          fontFamily: "'Playfair Display', serif"
        }} data-id="element-251">
            🪷 6 TOMOS COMPLETOS
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-252">
          {TOMOS.map((tomo, idx) => <div key={idx} className="bg-[#111111] border border-white/5 rounded-xl p-5 sm:p-6 flex flex-col h-full hover:border-[#eab308]/30 transition-colors" data-id="element-253">
              <div className="flex items-start gap-3 mb-3" data-id="element-254">
                <span className="text-3xl leading-none" data-id="element-255">{tomo.emoji}</span>
                <div data-id="element-256">
                  <span className="text-[#eab308] text-[10px] font-bold tracking-widest uppercase block mb-1" data-id="element-257">
                    Tomo {tomo.num}
                  </span>
                  <h3 className="text-lg font-bold text-white leading-tight" data-id="element-258">
                    {tomo.title}
                  </h3>
                </div>
              </div>
              <p className="text-gray-300 text-sm leading-relaxed mt-2" data-id="element-259">
                {tomo.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-10 bg-[#111111] border border-white/10 rounded-xl p-6 text-center max-w-2xl mx-auto" data-id="element-260">
          <p className="text-white font-bold mb-4" data-id="element-261">Cada tomo incluye:</p>
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-gray-300" data-id="element-262">
            <span className="flex items-center gap-1.5" data-id="element-263">
              <span className="text-[#eab308]" data-id="element-264">✅</span> Protocolos paso a paso
            </span>
            <span className="flex items-center gap-1.5" data-id="element-265">
              <span className="text-[#eab308]" data-id="element-266">✅</span> Guías de sesión
            </span>
            <span className="flex items-center gap-1.5" data-id="element-267">
              <span className="text-[#eab308]" data-id="element-268">✅</span> Técnicas detalladas
            </span>
            <span className="flex items-center gap-1.5" data-id="element-269">
              <span className="text-[#eab308]" data-id="element-270">✅</span> Integración práctica
            </span>
            <span className="flex items-center gap-1.5" data-id="element-271">
              <span className="text-[#eab308]" data-id="element-272">✅</span> Contexto argentino
            </span>
          </div>
        </div>
      </div>
    </section>;
}